/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-imports */

import React, { useEffect, useContext } from 'react';
import type { RefObject } from 'react';
import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import { Text } from '@oneaudi/unified-web-components';
import { renderTextWithFootnotesReferencesV2 } from '@oneaudi/feature-app-utils';
import type { WltpProps } from '../../../helper/consumptionEmission';
import { VueServiceHelper } from '../../../helper/consumptionEmission';
import { generateUUID } from '../../../helper/generateUUID';
import { WLTPContainer, MediaDisclaimerContainer } from './style';
import { ContentContext } from '../../contexts';

type WLTPComponentsProps = {
  wltpTextValues: string[];
  mediaDisclaimer: string[];
  localeService?: LocaleServiceV1;
  wltpRef: RefObject<HTMLParagraphElement> | null;
};

const WLTPComponent: React.FC<WLTPComponentsProps> = ({
  mediaDisclaimer,
  wltpTextValues,
  localeService,
  wltpRef,
  ...ueProps
}) => {
  // eslint-disable-next-line
  const context: any = useContext(ContentContext);
  const { vueFormatterService } = context;

  // const { localeService } = vueFormatterService;

  const [vueTexts, setVueTexts] = React.useState([] as WltpProps[]);

  useEffect(() => {
    if (wltpTextValues && localeService && vueFormatterService)
      VueServiceHelper.getConsumptionAndEmission(
        wltpTextValues,
        setVueTexts,
        vueFormatterService,
        localeService,
      );
  }, [wltpTextValues]);

  return (
    <div {...ueProps}>
      {mediaDisclaimer?.length > 0 ||
      (vueTexts && wltpTextValues.length > 0) ||
      typeof mediaDisclaimer === 'string' ? (
        <WLTPContainer
          className={`fg-wltp-content `}
          data-testid="carouselLegalText"
          key="fg-wltp-content"
          {...ueProps}
          isAlpha={!process.env.IS_LEGACY}
        >
          {vueTexts &&
            vueTexts?.map(
              (
                {
                  formattedConsumption,
                  formattedEmission,
                  formattedCo2Class,
                  formattedDischargedCo2Class,
                  formattedDischargedConsumption,
                },
                index,
              ) => (
                <Text
                  data-testid={`carouselWltpValue-${index + 1}`}
                  tag="p"
                  variant={{ type: 'copy', order: '2', style: 'normal' }}
                  key={index}
                  ref={wltpRef}
                >
                  <span>
                    {formattedConsumption && (
                      <span className="fg-wltp-items" tabIndex={-1} key={generateUUID()}>
                        {formattedConsumption};
                      </span>
                    )}
                    {formattedEmission && (
                      <span className="fg-wltp-items" tabIndex={-1} key={generateUUID()}>
                        {formattedEmission};
                      </span>
                    )}
                    {formattedCo2Class && (
                      <span className="fg-wltp-items" tabIndex={-1} key={generateUUID()}>
                        {formattedCo2Class}
                        {formattedDischargedConsumption || formattedDischargedCo2Class ? ';' : ''}
                      </span>
                    )}
                    {formattedDischargedConsumption && (
                      <span className="fg-wltp-items" tabIndex={-1} key={generateUUID()}>
                        {formattedDischargedConsumption}
                        {formattedDischargedCo2Class ? ';' : ''}
                      </span>
                    )}
                    {formattedDischargedCo2Class && (
                      <span className="fg-wltp-items" tabIndex={-1} key={generateUUID()}>
                        {formattedDischargedCo2Class}
                      </span>
                    )}
                  </span>
                </Text>
              ),
            )}

          <MediaDisclaimerContainer
            $show={Boolean(mediaDisclaimer?.length)}
            data-testid="carouselMediaDisclaimer"
            key="mediaDisclaimer"
          >
            {mediaDisclaimer &&
              (typeof mediaDisclaimer === 'string' ? (
                <Text
                  data-testid="carouselMediaDisclaimerItem-1"
                  tag="p"
                  variant={{ type: 'copy', order: '2', style: 'normal' }}
                >
                  {renderTextWithFootnotesReferencesV2(mediaDisclaimer)}
                </Text>
              ) : (
                mediaDisclaimer?.map((disclaimer, index) => (
                  <Text
                    data-testid={`carouselMediaDisclaimerItem-${index + 1}`}
                    key={index}
                    tag="p"
                    variant={{ type: 'copy', order: '2', style: 'normal' }}
                  >
                    {renderTextWithFootnotesReferencesV2(disclaimer)}
                  </Text>
                ))
              ))}
          </MediaDisclaimerContainer>
        </WLTPContainer>
      ) : null}
    </div>
  );
};

export default WLTPComponent;
